/**
 * The cartoon's watch-time events, shared by both funnels.
 *
 *   Cartoon Scene Started  — each scene as it begins (1-based), so a drop-off
 *                            curve per scene is one report.
 *   Cartoon Watched        — once per viewing, with how long they watched
 *                            (`watched_sec`, playing time only), how far they
 *                            got (`position_sec`, `watched_pct` 0–100) and how
 *                            it ended (`outcome`: ended / gate / left).
 *
 * The same numbers land on the profile, so "parents who watched under 20 s"
 * is a segment and not an event query.
 */
import { analytics } from '../analytics';
import type { WatchReport } from './CartoonPlayer';

export function trackScene(scene: number, scenesTotal: number): void {
  analytics.event('Cartoon Scene Started', { scene, scenes_total: scenesTotal });
}

export function trackWatch(w: WatchReport): void {
  const props = {
    outcome: w.outcome,
    watched_sec: Math.round(w.watchedSec),
    position_sec: Math.round(w.positionSec),
    total_sec: Math.round(w.totalSec),
    watched_pct: Math.round(w.watchedPct * 100),
    scene: w.scene,
    scenes_total: w.scenesTotal,
    restarts: w.restarts,
    fullscreen: w.fullscreen,
  };
  // "left" fires as the page goes away; a batched event would not make it out.
  if (w.outcome === 'left') analytics.eventNow('Cartoon Watched', props);
  else analytics.event('Cartoon Watched', props);
  if (w.watchedSec >= 1) {
    analytics.person({
      'Cartoon Watched Sec': props.watched_sec,
      'Cartoon Watched Pct': props.watched_pct,
      'Cartoon Outcome': w.outcome,
    });
  }
}
